import Helmet from 'react-helmet';

const JeenaHead = () => {
  return (
    <Helmet>
      {/* Required meta tags */}
      <meta charSet="utf-8" />
      <meta name="description" content="" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      {/* Title */}
      <title>
        AIVATAR
      </title>
      {/* Favicon Icon */}
      <link
        rel="shortcut icon"
        href="assets/images/favicon1.png"
        type="image/x-icon"
      />
      {/* Google Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;600&family=Roboto:wght@400;500;700&display=swap"
        rel="stylesheet"
      />
      {/* Flaticon */}
      <link rel="stylesheet" href="assets/css/flaticon.min.css" />
      {/* Font Awesome */}
      <link rel="stylesheet" href="assets/css/fontawesome-5.14.0.min.css" />
      {/* Bootstrap */}
      <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
      {/* Magnific Popup */}
      <link rel="stylesheet" href="assets/css/magnific-popup.min.css" />
      {/* Nice Select */}
      <link rel="stylesheet" href="assets/css/nice-select.min.css" />
      {/* Animate */}
      <link rel="stylesheet" href="assets/css/animate.min.css" />
      {/* Slick */}
      <link rel="stylesheet" href="assets/css/slick.min.css" />
      {/* Main Style */}
      <link rel="stylesheet" href="assets/css/style.css" />
    </Helmet>
  );
};
export default JeenaHead;
